/* eslint-disable */

var externalLink = function (params) {
	return {
		init: function () {
			this.wrapper = params.wrapper
			this.name = params.name
			this.disabled = params.disabled
			this.valueToPrefill = params.valueToPrefill

			// create container for these fields
			var container = document.createElement('div')
			container.classList.add('link-wrapper')

			// split the prefilled value
			var valueTxt = null
			var valueLink = null
			if (this.valueToPrefill) {
				valueTxt = this.valueToPrefill[0]
				valueLink = this.valueToPrefill[1]
			}

			var labelWrapper = document.createElement('div')

			// create text input in case we want to render an HTML link
			var input = document.createElement('input')
			input.setAttribute('type', 'text')
			input.setAttribute('name', this.name)
			input.setAttribute('placeholder', 'Link label')
			if (this.required) input.setAttribute('required', this.required)
			if (valueTxt) input.value = valueTxt
			if (this.disabled) input.setAttribute('disabled', 'true')

			labelWrapper.appendChild(input)

			var linkWrapper = document.createElement('div')

			var input1 = document.createElement('input')
			input1.setAttribute('type', 'text')
			input1.setAttribute('name', this.name)
			input1.setAttribute('placeholder', 'Url')
			// if (this.pattern) input1.setAttribute('pattern', this.pattern)

			// allow http:// - https:// and showpad://
			input1.setAttribute('pattern', '^https?:\/\/|^showpad:\/\/')
			if (this.required) input1.setAttribute('required', this.required)
			if (this.valueToPrefill) input1.value = valueLink
			if (this.disabled) input1.setAttribute('disabled', 'true')

			linkWrapper.appendChild(input1)

			container.appendChild(labelWrapper)
			container.appendChild(linkWrapper)

			var desc = document.createElement('div')
			desc.setAttribute('class', 'description')
			desc.innerHTML += 'Link to public website (URL start with HTTP:// or HTTPS://) or link to Showpad Channel (URL  start with Showpad://).'
			container.appendChild(desc)

			this.wrapper.appendChild(container)
			// this.callback(this.conditionalLinkData)
		}
	}
}

export default externalLink
